import Vue from 'vue'
import Vuex from 'vuex'
import {
  SHOW_APP_MUTATION,
  SHOW_APP_ACTION,
  LOGIN_ACTION,
  LOGIN_MUTATION,
  LOGOUT_ACTION,
  LOGOUT_MUTATION,
  SET_INIT_DATA_MUTATION,
  SET_INIT_DATA_ACTION,
  ADD_TO_TEST_DEFINITION_CACHE_ACTION,
  ADD_TO_TEST_DEFINITION_CACHE_MUTATION,
  RESET_STATE_ACTION,
  RESET_STATE_MUTATION,
  SET_REQUESTED_BY_DOCTORS_ACTION,
  SET_REQUESTED_BY_DOCTORS_MUTATION,
  SET_COLLECTION_CENTERS_ACTION,
  SET_COLLECTION_CENTERS_MUTATION
} from './store-constants.js'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,

  plugins: [
    createPersistedState({})
  ],

  state: {
    token: null,
    showApp: false, // used to show hide app until the initial health check call is done
    username: '',
    userroles: [],
    tests: null,
    testIdToTestDefinitionId: null,
    testDefinitionCache: {} // test definition id to test definition
  },

  mutations: {
    [SHOW_APP_MUTATION](state, token) {
      state.showApp = true;
    },

    [LOGIN_MUTATION](state, token) {
      state.token = token;
    },

    [LOGOUT_MUTATION](state) {
      state.token = null;
    },

    [SET_INIT_DATA_MUTATION](state, data) {
      state.username = data.username;
      state.userroles = data.userroles;
      state.tests = data.tests;
      state.testIdToTestDefinitionId = data.testIdToTestDefinitionId;
    },

    [ADD_TO_TEST_DEFINITION_CACHE_MUTATION](state, data) {
      state.testDefinitionCache[data.id] = data.definition;
    },

    [RESET_STATE_MUTATION](state) {
      state.token = null;
      state.username = '';
      state.tests = null;
      state.testIdToTestDefinitionId = null;
      state.testDefinitionCache = {};
    },

    [SET_REQUESTED_BY_DOCTORS_MUTATION](state, data) {
      state.requestedByDoctors = data;
    },

    [SET_COLLECTION_CENTERS_MUTATION](state, data) {
      state.collectionCenters = data;
    }

  },

  actions: {
    [SHOW_APP_ACTION](context) {
      context.commit(SHOW_APP_MUTATION);
    },

    [LOGIN_ACTION](context, token) {
      context.commit(LOGIN_MUTATION, token);
    },

    [LOGOUT_ACTION](context) {
      context.commit(LOGOUT_MUTATION);
      context.commit(RESET_STATE_MUTATION);
    },

    [SET_INIT_DATA_ACTION](context, data) {
      context.commit(SET_INIT_DATA_MUTATION, data);
    },

    [ADD_TO_TEST_DEFINITION_CACHE_ACTION](context, data) {
      context.commit(ADD_TO_TEST_DEFINITION_CACHE_MUTATION, data);
    },

    [RESET_STATE_ACTION](context) {
      context.commit(RESET_STATE_MUTATION);
    },

    [SET_REQUESTED_BY_DOCTORS_ACTION](context, data) {
      context.commit(SET_REQUESTED_BY_DOCTORS_MUTATION, data);
    },

    [SET_COLLECTION_CENTERS_ACTION](context, data) {
      context.commit(SET_COLLECTION_CENTERS_MUTATION, data);
    }

  },
  getters: {

    isAuthenticated: state => {
      return state.authenticated;
    },

    isShowApp: state => {
      return state.showApp;
    },

    username: state => {
      return state.username;
    },

    userroles: state => {
      return state.userroles;
    },

    tests: state => {
      if (state.tests == null) {
        return;
      }

      var sortedTests = state.tests.slice();

      sortedTests.sort(function (a, b) {
        return a.testName.localeCompare(b.testName);
      });
      return sortedTests;
    },

    testById: state => id => {
      return state.tests.find(test => test.id == id);
    },

    testDefinitionId: state => testId => {
      return state.testIdToTestDefinitionId[testId];
    },

    token: state => {
      return state.token;
    },

    testDefinitionCache: state => testDefinitionId => {
      return state.testDefinitionCache[testDefinitionId];
    },

    requestedByDoctors: state => {
      return state.requestedByDoctors;
    },

    collectionCenters: state => {
      return state.collectionCenters;
    }

  }
})